export const cardData = [
    {
        id:'1',
        img:"/assets/photosnap.svg",
        name:"Photonsnap",
        addOns:[{name:'New!',name2:'Featured'}],
        detail:"Senior Frontend Developer",
        day:"1d ago",
        time:"Full Time",
        location:"USA Only",
        tags:['Frontend', 'Senior','HTML','CSS','JavaScript']
    },
    {
        id:'2',
        img:"/assets/manage.svg",
        name:"Manage",
        addOns:[{name:'New!',name2:'Featured'}],
        detail:"Fullstack Developer",
        day:"1d ago",
        time:"Part Time",
        location:"Remote",
        tags:['Fullstack', 'Midweight','Python','React']
    },
    {
        id:'3',
        img:"/assets/account.svg",
        name:"Account",
        detail:"Junior Frontend Developer",
        day:"2d ago",
        time:"Part Time",
        location:"USA Only",
        tags:['Frontend','Junior','JavaScript','React','Sass']
    },
    {
        id:'4',
        img:"/assets/myhome.svg",
        name:"MyHome",
        detail:"Junior Frontend Developer",
        day:"5d ago",
        time:"Contract",
        location:"USA Only",
        tags:['Frontend','Junior','CSS','JavaScript']
    },
    {
        id:'5',
        img:"/assets/loopStudios.svg",
        name:"Loop Studios",
        detail:"Software Engineer",
        day:"1w ago",
        time:"Full Time",
        location:"Worldwide",
        tags:['Fullstack', 'Midweight','JavaScript','Ruby','Sass']
    },
    {
        id:'6',
        img:"/assets/faceit.svg",
        name:"FaceIt",
        detail:"Junior Backend Developer",
        day:"2w ago",
        time:"Full Time",
        location:"UK Only",
        tags:['Backend', 'Junior','Ruby','RoR']
    },
    {
        id:'7',
        img:"/assets/shortly.svg",
        name:"Shortly",
        detail:"Junior Developer",
        day:"2w ago",
        time:"Full Time",
        location:"Worldwide",
        tags:['Frontend','Junior','HTML','JavaScript','Sass']
    },
    {
        id:'8',
        img:"/assets/insure.svg",
        name:"Insure",
        detail:"Junior Frontend Developer",
        day:"2w ago",
        time:"Full Time",
        location:"USA Only",
        tags:['Frontend','Junior','JavaScript','Vue  ','Sass']
    },
    {
        id:'9',
        img:"/assets/eyecamCo.svg",
        name:"Eyecam Co.",
        detail:"Full Stack Engineer",
        day:"3w ago",
        time:"Full Time",
        location:"Worldwide",
        tags:['Fullstack', 'Midweight','JavaScript','Python','Django']
    },
    {
        id:'10',
        img:"/assets/theCompany.svg",
        name:"The Air Filter Company",
        detail:"Front-end Dev",
        day:"1mon ago",
        time:"Part Time",
        location:"Worldwide",
        tags:['Frontend','Junior','JavaScript','React','Sass']
    }
]